export function roundTo(num: number, places: number): number {
  if (places < 0) throw new Error("places must be >= 0");
  return +(Math.round(+(num + "e+" + places)) + "e-" + places);
}

export function roundToTwo(num: number): number {
  return roundTo(num, 2);
}

export function computeTaxAmount(
  subtotal: number,
  taxRatePercent: number
): number {
  const subtotalCents = Math.round(subtotal * 100);
  const taxRateMillis = Math.round(taxRatePercent * 1000);
  const taxMicro = subtotalCents * taxRateMillis;
  const taxCents = Math.round(taxMicro / 100000);
  return taxCents / 100;
}

export function computeTotalWithTax(
  subtotal: number,
  taxRatePercent: number
): number {
  return roundToTwo(subtotal + computeTaxAmount(subtotal, taxRatePercent));
}

export const calculateTaxRateValue = ({
  tax_rate,
  discount = 0,
  price
}: {
  price: string | number;
  tax_rate: string | number | undefined;
  discount: string | number | undefined;
}) => {
  if (!tax_rate) return 0;
  const subtotal = Number(price) - Number(discount);
  return computeTaxAmount(subtotal, Number(tax_rate));
};
